export default __webpack_public_path__ + "static/media/0144.0faf62fe.jpg";